import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HotJarSessionService {
  private readonly cookieKey = 'last_recorded_session';

  private readonly cookieDurationDays = 30;

  private readonly probability = 0.2;

  private readonly startHourRecordings = 9;

  private readonly endHourRecordings = 18;

  constructor(private readonly cookieService: CookieService) {}

  public isSessionValidForRecording(): boolean {
    if (!this.isWithinTimeWindow() || !this.shouldTriggerByChance(this.probability)) return false;

    const hasSession = this.cookieService.get(this.cookieKey);
    if (hasSession) {
      return false;
    }

    this.setControlCookie();
    return true;
  }

  private setControlCookie(): void {
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + this.cookieDurationDays);
    this.cookieService.set(this.cookieKey, 'true', expirationDate, '/', environment.domain);
  }

  private isWithinTimeWindow(): boolean {
    const now = new Date();
    const hour = now.getHours();
    return hour >= this.startHourRecordings && hour < this.endHourRecordings;
  }

  private shouldTriggerByChance(probability: number): boolean {
    const randomBuffer = new Uint32Array(1);
    window.crypto.getRandomValues(randomBuffer);
    const random = randomBuffer[0] / (0xffffffff + 1);
    return random < probability;
  }
}
